import { render } from "./InvoiceCreateInfoCard.vue?vue&type=template&id=0460f825"
import script from "./InvoiceCreateInfoCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCreateInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__